
class HubspotLoader {
    constructor() {
        this.HubspotElements = document.querySelectorAll("[data-formid]");
        this.initialize()
    }

    static get hubspotScriptUrl() {
        //return '/boat-contact-modal.json'
        return '//js-eu1.hsforms.net/forms/embed/v2.js';
    }

    initialize() {
        const HubspotElementsObserver = new IntersectionObserver(this.handleIntersect, {});

        for (const HubspotElement of this.HubspotElements) {
            HubspotElementsObserver.observe(HubspotElement);
        }
    }

    handleIntersect(entries, observer) {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                if (document.getElementById('hubspotLib')) return;
                HubspotLoader.injectScript(HubspotLoader.hubspotScriptUrl)
                .then(() => {
                    document.dispatchEvent(
                        new CustomEvent('hs-loaded')
                    );
                }).catch(error => {
                    console.error(error);
                });
                observer.unobserve(entry.target);
            }
        }
    }
    static async injectScript(src) {
        return await new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.id = 'hubspotLib';
            script.addEventListener('load', resolve);
            script.addEventListener('error', e => reject(e.error));
            document.head.appendChild(script);
        });
    }

}

document.addEventListener("DOMContentLoaded", () =>  {
    if (document.querySelectorAll('[data-formid]').length) {
         new HubspotLoader()
    }
});
